// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3HED6","title":"card_title__3aqSH","inActive":"card_inActive__2Jm8q"};